import { render, staticRenderFns } from "./ChatBodyMobile.vue?vue&type=template&id=404116fc&"
import script from "./ChatBodyMobile.vue?vue&type=script&lang=js&"
export * from "./ChatBodyMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports